import React from "react";
import "../../../style/header.css";
import HeaderOne from "../../../images/Header-Image/Apply of Flower Inducing Chemicals for Pineapple Production.jpg";
import HeaderTwo from "../../../images/Header-Image/Distribution of Saplings.jpg";
import HeaderThree from "../../../images/Header-Image/Distribution of Fertilizers.jpg";
import HeaderFour from "../../../images/Header-Image/Distribution of Saplings2.jpg";
import HeaderFive from "../../../images/Header-Image/Farmers’ Training Program on Year-Round Pineapple Production Through Flower Inducing Chemicals.jpg";
import HeaderSix from "../../../images/Header-Image/Farmers’ Training on Hopper and Borer Control in Mango Trees.jpg";
import HeaderSeven from "../../../images/Header-Image/Pineapple Garden visit by BARC agriculture research team.jpg";
import HeaderEight from "../../../images/Header-Image/Vegetable Gardening.jpg";
import HeaderNine from "../../../images/Header-Image/Zinger Cultivation.jpg";
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

const Header = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="header_image_section">
      <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img src={HeaderOne} alt="" />
          <Carousel.Caption className="content">
            <p>
              Apply of Flower Inducing Chemicals for Pineapple Production
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderTwo} alt="" />
          <Carousel.Caption className="content">
            <p>
              Distribution of Saplings
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderThree} alt="" />
          <Carousel.Caption className="content">
            <p>
              Distribution of Fertilizers
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderFour} alt="" />
          <Carousel.Caption className="content">
            <p>
              Distribution of Saplings
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderFive} alt="" />
          <Carousel.Caption className="content">
            <p>
              Farmers’ Training on Hopper and Borer Control in Mango Trees
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderSix} alt="" />
          <Carousel.Caption className="content">
            <p>
              Farmers’ Training Program on Year-Round Pineapple Production Through Flower Inducing Chemicals
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderSeven} alt="" />
          <Carousel.Caption className="content">
            <p>
              Pineapple Garden visit by BARC agriculture research team
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderEight} alt="" />
          <Carousel.Caption className="content">
            <p>
              Vegetable Gardening
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img src={HeaderNine} alt="" />
          <Carousel.Caption className="content">
            <p>
              Zinger Cultivation
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Header;
